<template>
  <div class="Loyalty-banner">
    <div class="Loyalty-banner__content">
      <ux-atoms-icon :name="logo" color="white" size="xl" />
      <div class="Loyalty-banner__texts">
        <ux-atoms-typo as="h2" color="white" variant="text-heading-02">{{ title }}</ux-atoms-typo>
        <ux-atoms-typo as="p" color="white" v-if="subtitle" variant="text-regular">{{ subtitle }}</ux-atoms-typo>
      </div>
    </div>
    <div class="Loyalty-banner__buttons">
      <ux-atoms-link
        :classic="false"
        :target="externalSecondaryLink ? '_blank' : '_self'"
        :to="secondaryButtonLink"
        class="Button Button--outlined-white Button--l"
        v-if="secondaryButtonLabel && secondaryButtonLink && !isCurrentPage(secondaryButtonLink)"
        >{{ secondaryButtonLabel }}</ux-atoms-link
      >
      <ux-atoms-link
        :classic="false"
        :target="externalLink ? '_blank' : '_self'"
        :to="buttonLink"
        class="Button Button--action Button--l"
        v-if="buttonLink && buttonLabel && !isCurrentPage(buttonLink)"
        >{{ buttonLabel }}</ux-atoms-link
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';

enum LoyaltyLogo {
  AccorPlus = 'logo-accorplus',
  All = 'logo-all'
}

interface Props {
  buttonLabel?: null | string;
  buttonLink?: null | string;
  external?: boolean | null;
  externalSecondary?: boolean | null;
  logo: LoyaltyLogo;
  secondaryButtonLabel?: null | string;
  secondaryButtonLink?: null | string;
  subtitle?: null | string;
  title: string;
}

const props = withDefaults(defineProps<Props>(), {
  buttonLabel: undefined,
  buttonLink: undefined,
  external: undefined,
  externalSecondary: undefined,
  secondaryButtonLabel: undefined,
  secondaryButtonLink: undefined,
  subtitle: undefined
});

const config = useRuntimeConfig();
const route = useRoute();

const externalLink = computed(() => (props.external !== undefined ? props.external : isExternal(props.buttonLink)));

const externalSecondaryLink = computed(() =>
  props.externalSecondary !== undefined ? props.externalSecondary : isExternal(props.secondaryButtonLink)
);

const isExternal = (url?: null | string) => {
  return !url?.startsWith(config.public.baseUrl);
};

const isCurrentPage = (url: string) => {
  return (new URL(url).pathname.replace(/^\/(fr|en)(?=\/|$)/, '') || '/') === (route.path.replace(/^\/(fr|en)(?=\/|$)/, '') || '/');
};
</script>

<style lang="scss" scoped>
@use 'LoyaltyBanner.scss';
</style>
